export const EMAIL_JS = {
  serviceID: process.env.REACT_APP_SERVICE_ID as string,
  templateID: process.env.REACT_APP_TEMPLATE_ID as string,
  publicKey: process.env.REACT_APP_PUBLIC_KEY as string,
};

export const DISABLE_PAYMENT = process.env.REACT_APP_DISABLE_PAYMENT as string;

export const BASE_URL = process.env.REACT_APP_BASE_URL;
